module.exports = __webpack_public_path__ + "img/card_hj@2x.e4da18ed.png";